import { auth } from '../firebase';

const BASE_URL = '/.netlify/functions';

const getHeaders = async () => {
    const token = await auth.currentUser?.getIdToken();
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export const adminApi = {
    whoami: async () => {
        const headers = await getHeaders();
        const res = await fetch(`${BASE_URL}/admin-whoami`, { headers });
        if (!res.ok) throw new Error('Not verified');
        return res.json();
    },

    listUsers: async (search?: string) => {
        const headers = await getHeaders();
        const query = search ? `?search=${encodeURIComponent(search)}` : '';
        const res = await fetch(`${BASE_URL}/admin-list-users${query}`, { headers });
        if (!res.ok) throw new Error('Failed to list users');
        return res.json();
    },

    getUser: async (uid: string) => {
        const headers = await getHeaders();
        const res = await fetch(`${BASE_URL}/admin-get-user?uid=${uid}`, { headers });
        if (!res.ok) throw new Error('Failed to get user');
        return res.json();
    },

    setEntitlements: async (uid: string, action: string, payload?: any) => {
        const headers = await getHeaders();
        const res = await fetch(`${BASE_URL}/admin-set-entitlements`, {
            method: 'POST',
            headers,
            body: JSON.stringify({ uid, action, payload })
        });
        if (!res.ok) throw new Error('Failed to set entitlement');
        return res.json();
    }
};
